var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloud2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3245_4213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0883 19.9234C13.0883 12.7785 18.8804 6.98633 26.0254 6.98633H64.1511C71.2961 6.98633 77.0883 12.7785 77.0883 19.9234V58.0492C77.0883 65.1942 71.2961 70.9863 64.1511 70.9863H26.0254C18.8804 70.9863 13.0883 65.1942 13.0883 58.0492V19.9234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0254 7.39061H64.1511C71.0728 7.39061 76.684 13.0018 76.684 19.9234V58.0492C76.684 64.9709 71.0728 70.582 64.1511 70.582H26.0254C19.1037 70.582 13.4925 64.9709 13.4925 58.0492V19.9234C13.4925 13.0018 19.1037 7.39061 26.0254 7.39061Z",
    stroke: "#B1C1CF",
    strokeWidth: 0.808569
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7188 36.223C44.0127 36.223 45.8723 34.3635 45.8723 32.0695C45.8723 29.7756 44.0127 27.916 41.7188 27.916C39.4249 27.916 37.5653 29.7756 37.5653 32.0695C37.5653 34.3635 39.4249 36.223 41.7188 36.223Z",
    stroke: "#243251",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2413 40.167C42.0241 39.928 40.759 39.9261 39.5408 40.1615C38.3225 40.3969 37.1826 40.8635 36.2062 41.5265C35.2298 42.1895 34.4422 43.0316 33.9023 43.99C33.3624 44.9483 33.0841 45.9981 33.0883 47.0608V49.4163H43.2413M51.8622 50.9396C51.6594 51.0019 51.4373 51.0019 51.2345 50.9396C49.695 50.4207 48.374 49.5207 47.4426 48.356C46.5112 47.1913 46.0122 45.8156 46.0103 44.4069V42.3498C46.0022 42.2449 46.0205 42.1397 46.064 42.0413C46.1075 41.9429 46.1752 41.8535 46.2626 41.7792C46.35 41.7049 46.455 41.6473 46.5707 41.6103C46.6864 41.5733 46.81 41.5577 46.9333 41.5646H56.1634C56.2867 41.5577 56.4103 41.5733 56.526 41.6103C56.6417 41.6473 56.7467 41.7049 56.8341 41.7792C56.9215 41.8535 56.9892 41.9429 57.0327 42.0413C57.0762 42.1397 57.0945 42.2449 57.0864 42.3498V44.4069C57.0845 45.8156 56.5855 47.1913 55.6541 48.356C54.7227 49.5207 53.4017 50.4207 51.8622 50.9396Z",
    stroke: "#243251",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3245_4213",
    x: 0.151146,
    y: 0.517773,
    width: 89.8742,
    height: 89.8742,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.46856
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.46856
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.615686 0 0 0 0 0.686275 0 0 0 0 0.776471 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3245_4213"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3245_4213",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud2);
export default __webpack_public_path__ + "static/media/Cloud2.c8f62fe706fe59a8dd9a3140914af38b.svg";
export { ForwardRef as ReactComponent };